<script setup>
    import { defineProps } from 'vue'

    const props = defineProps({
        content: { type: String, required: true },
        color: { type: String, default: 'warning' },
        space: { type: String, default: '1' },
    })
    const isColor = {
        infor: 'bg-blue-50 border-blue-400 text-blue-800 dark:border-blue-300 dark:bg-blue-400',
        warning : 'bg-yellow-100 border-yellow-400 text-yellow-700 dark:border-yellow-300 dark:bg-yellow-300',
    }
    const isSpace = {
        '1': 'py-1',
        '2': 'py-2',
        '3': 'py-3',
        '4': 'py-3',
    }
</script>

<template>
    <mark
        class=" border-dotted  px-2 rounded-lg text-xs dark:border-dotted  dark:bg-opacity-25 dark:text-gray-300"
        :class="[isSpace[props.space], isColor[props.color]]"
        v-html="props.content"
    />
</template>
